import { render, staticRenderFns } from "./componentFormer.vue?vue&type=template&id=4a147b28&"
import script from "./componentFormer.vue?vue&type=script&lang=js&"
export * from "./componentFormer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports